const REPLACEMENTS: Record<string, string> = {
  Ä: 'Ae',
  ä: 'ae',
  Ö: 'Oe',
  ö: 'oe',
  Ü: 'Ue',
  ü: 'ue',
  ß: 'ss',
};

/**
 * Transforms the given text for use as a slug in a URL.
 *
 * @see https://www.seo.com/basics/glossary/url-slug/
 */
export function slugify(text: string) {
  return (
    text
      // Replace German umlauts and ß
      .replace(new RegExp(`[${Object.keys(REPLACEMENTS).join('')}]`, 'g'), (char) => REPLACEMENTS[char])
      // Remove reserved characters
      // (see section 2.3: https://www.ietf.org/rfc/rfc3986.txt)
      .replace(/[^\w\-.~ ]+/g, '')
      // Replace subsequent whitespace and dashes with a single dash
      .replace(/[\s-]+/g, '-')
  );
}
